import { HttpClient } from "@/app/api/HttpClient"
import { API_PREFIX_CAMPAIGNS_PATH } from "@/constants/prefix-path-api"
// IMPORT TẤT CẢ INTERFACE TỪ FILE TYPE CHUNG ĐỂ ĐỒNG BỘ
import { message } from "@/lib/config/lib/antd-global"
import { CampaignPayload, FilterSearchParams } from "@/types/types"

type CampaignListQueryParams = Omit<FilterSearchParams, "populate" | "fields"> & {
  fields?: string[]
  populate?: string | Record<string, any>
}

const CAMPAIGN_LIST_FIELDS = ["name", "dateFrom", "dateTo", "relatedProducts", "tamdaExpressCampaign", "publishedAt"]
const CAMPAIGN_LIST_POPULATE = {
  posts: {
    fields: ["title", "name"],
  },
  campaign_subscribers: {
    fields: ["fullname", "phone"],
  },
  tamdaStores: {
    fields: ["name"],
  },
}

export const fetchCampaigns = async (searchTerms: { [key: string]: any } = {}) => {
  const params: CampaignListQueryParams = {
    fields: CAMPAIGN_LIST_FIELDS,
    populate: CAMPAIGN_LIST_POPULATE,
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      withCount: true,
    },
  }

  // Logic xử lý publicationState cho Tabs
  if (searchTerms.publicationState === "draft") {
    params.publicationState = "preview"
    // Lấy những bản nháp
    params.filters.publishedAt = { $null: true }
  } else if (searchTerms.publicationState === "live") {
    // Strapi mặc định chỉ lấy bản đã publish
    params.publicationState = "live"
  } else {
    // Trường hợp "All" (preview)
    params.publicationState = "preview"
  }

  const excludedKeys = [
    "current",
    "pageSize",
    "start",
    "limit",
    "total",
    "page",
    "sort",
    "fields",
    "populate",
    "publicationState",
  ]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "sort") {
      params.sort = value
    } else if (key === "fields") {
      params.fields = String(value)
        .split(",")
        .map((field: string) => field.trim())
        .filter(Boolean)
    } else if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value && key !== "publicationState") {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  // Set default pageSize if not provided
  if (!params.pagination) {
    params.pagination = { withCount: true }
  }
  if (!params.pagination.pageSize) {
    params.pagination.pageSize = "20"
  }

  try {
    const response = await HttpClient.get(`${API_PREFIX_CAMPAIGNS_PATH}`, { params,skipDomainFilter:true },)
    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error("Lỗi khi tải danh sách chiến dịch. Vui lòng thử lại.")
    throw error
  }
}

/**
 * LẤY CHI TIẾT MỘT CAMPAIGN THEO ID
 */
export const fetchCampaignId = async (id: number | string) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_CAMPAIGNS_PATH}/${id}?populate=*`,{skipDomainFilter:true})
    return response.data
  } catch (error) {
    message.error("Lỗi khi tải thông tin chiến dịch. Vui lòng thử lại.")
    throw error
  }
}

/**
 * XÓA CAMPAIGN
 */
export const deleteCampaign = async (id: number | string) => {
  try {
    return await HttpClient.delete(`${API_PREFIX_CAMPAIGNS_PATH}/${id}`,{skipDomainFilter:true})
  } catch (error) {
    message.error("Lỗi khi xóa chiến dịch. Vui lòng thử lại.")
    throw error
  }
}

/**
 * CẬP NHẬT THÔNG TIN CAMPAIGN (SỬ DỤNG INTERFACE TỪ TYPE.TS)
 */
export const updateCampaign = async (id: number | string, data: CampaignPayload) => {
  try {
    return await HttpClient.put(`${API_PREFIX_CAMPAIGNS_PATH}/${id}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error("Lỗi khi cập nhật chiến dịch. Vui lòng thử lại.")
    throw error
  }
}

/**
 * THÊM MỚI CAMPAIGN (SỬ DỤNG INTERFACE TỪ TYPE.TS)
 */
export const addCampaign = async (data: CampaignPayload) => {
  try {
    return await HttpClient.post(`${API_PREFIX_CAMPAIGNS_PATH}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error("Lỗi khi thêm chiến dịch. Vui lòng thử lại.")
    throw error
  }
}

/**
 * XUẤT FILE CSV CAMPAIGN THEO ID — gọi endpoint Strapi và tải file về
 */
export const exportCampaign = async (id: number | string, campaignName?: string): Promise<void> => {
  const filename = campaignName ? `campaign-${campaignName}` : `campaign-${id}`
  await HttpClient.downloadFile(`/api/campaign/export?campaign_id=${id}`, filename)
}
